module.exports = "<div class=nn-addon-slideshow><nn-base-swiper class=nn-addon-slideshow__swiper options=swiperOptions><div class=\"nn-addon-slideshow__slide js-swiper-slide\" ng-repeat=\"image in slideshowSettings.images\"><nn-base-img class=slide__img src=::image.content alt=::image.translations[$root.lang].title aspect-ratio=aspectRatio no-lazy=true></nn-base-img><p class=slide__caption ng-bind-html=image.translations[$root.lang].title></p></div></nn-base-swiper></div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-add-ons/nn-addon-slideshow/nn-addon-slideshow.directive.html
// module id = 945
// module chunks = 0